import { initialGloveImagesState, initialPersonalState, initialEmbroideryState } from 'src/constants'
import { BaseInitialState, State } from 'src/types'

export const unselectedStateTw = { label: '未選擇', value: 'unselected' }
export const unselectedColorStateTw = { label: '未選擇', value: 'unselected', color: '#fff' }
export const unselectedStateWithPriceTw = { label: '未選擇', value: 'unselected', price: 0 }

export const baseInitialStateTw: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedStateTw,
  dominantArm: unselectedStateTw,
  size: unselectedStateTw,
  fingerGuardType: unselectedStateTw,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: 'unselected',
    position: 'infielder', // 本当はここ、infielderでありたくない
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const colorInitialStateTw = {
  parts: { label: '全部', value: 'all' },
  all: unselectedColorStateTw,
  catchFace: unselectedColorStateTw,
  edge: unselectedColorStateTw,
  lace: unselectedColorStateTw,
  linings: unselectedColorStateTw,
  hamidashi: unselectedColorStateTw,
  listLiningsMaterial: unselectedColorStateTw,
  stitch: { label: '未選擇', value: 'unselected', color: '#eee' },
  web: unselectedColorStateTw,
  web2: unselectedColorStateTw,
  thumbHook: unselectedColorStateTw,
  littleHook: unselectedColorStateTw,
  listBelt: unselectedColorStateTw,
  indexCover: unselectedColorStateTw
}

export const gloveColorInitialStateTw = {
  thumbOut: unselectedColorStateTw,
  thumbWeb: unselectedColorStateTw,
  thumbRoot: unselectedColorStateTw,
  thumbWebAndIndexWeb: unselectedColorStateTw,
  thumbIndexMiddle: unselectedColorStateTw,
  indexWeb: unselectedColorStateTw,
  indexMiddle: unselectedColorStateTw,
  indexLeftMiddleRight: unselectedColorStateTw,
  middleIndex: unselectedColorStateTw,
  middleLeftRingRight: unselectedColorStateTw,
  middleRing: unselectedColorStateTw,
  ringMiddle: unselectedColorStateTw,
  ringLeftLittleRight: unselectedColorStateTw,
  ringLittle: unselectedColorStateTw,
  littleRing: unselectedColorStateTw,
  littleOut: unselectedColorStateTw
}

export const initialPitcherStateTw: State = {
  ...baseInitialStateTw,
  ...colorInitialStateTw,
  ...gloveColorInitialStateTw,
  tanner: unselectedStateTw,
  loopOfRingFinger: unselectedStateTw,
  loopOfRingFingerColor: unselectedColorStateTw,
  backLace: unselectedStateTw,
  backStyle: unselectedStateTw,
  materialPack: unselectedStateTw,
  webParts: unselectedStateTw,
  printLeatherType: unselectedStateTw,
  mouton: unselectedColorStateTw,
  atomsLabel: unselectedStateTw,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialInfielderStateTw = {
  ...baseInitialStateTw,
  tanner: unselectedStateTw,
  backLace: unselectedStateWithPriceTw,
  beltType: unselectedStateWithPriceTw,
  webParts: unselectedStateTw,
  printLeatherType: unselectedStateWithPriceTw,
  size: unselectedStateWithPriceTw,
  leatherIntegratedMiddle: unselectedStateWithPriceTw,
  loopOfRingFinger: unselectedStateWithPriceTw,
  loopOfRingFingerColor: unselectedColorStateTw,
  ...colorInitialStateTw,
  ...gloveColorInitialStateTw,
  mouton: unselectedStateTw,
  atomsLabel: unselectedStateTw,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialOutfielderStateTw: State = {
  ...baseInitialStateTw,
  ...colorInitialStateTw,
  ...gloveColorInitialStateTw,
  loopOfRingFinger: unselectedStateTw,
  loopOfRingFingerColor: unselectedColorStateTw,
  tanner: unselectedStateTw,
  backLace: unselectedStateTw,
  webParts: unselectedStateTw,
  printLeatherType: unselectedStateWithPriceTw,
  mouton: unselectedStateTw,
  atomsLabel: unselectedStateTw,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialStateCatcherMittTw: State = {
  ...baseInitialStateTw,
  ...colorInitialStateTw,
  tanner: unselectedStateTw,
  backStyle: unselectedStateTw,
  thumb: unselectedColorStateTw,
  webParts: unselectedStateTw,
  printLeatherType: unselectedStateTw,
  thumbIndexMiddleRight: unselectedColorStateTw,
  catchFaceTarget: unselectedColorStateTw,
  indexAndMiddle: unselectedColorStateTw,
  middleRing: unselectedColorStateTw,
  middleLeftRingLittle: unselectedColorStateTw,
  middleLeftRing: unselectedColorStateTw,
  littleRing: unselectedColorStateTw,
  littleOut: unselectedColorStateTw,
  fingerStand: unselectedColorStateTw,
  indexFingerTipOut: unselectedColorStateTw,
  mouton: unselectedColorStateTw,
  atomsLabel: unselectedStateTw,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialStateFirstMittTw: State = {
  ...baseInitialStateTw,
  ...colorInitialStateTw,
  tanner: unselectedStateTw,
  loopOfRingFinger: unselectedStateTw,
  loopOfRingFingerColor: unselectedColorStateTw,
  webParts: unselectedStateTw,
  printLeatherType: unselectedStateTw,
  thumb: unselectedColorStateTw,
  underWeb: unselectedColorStateTw,
  boomerang: unselectedColorStateTw,
  mouton: unselectedStateTw,
  atomsLabel: unselectedStateTw,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}
